export function replaceKeys(data, keyMap) {
    if (Array.isArray(data)) {
        return data.map((item) => replaceKeys(item, keyMap))
    } else if (data && typeof data === 'object') {
        const newObj = {}
        for (const key in data) {
            if (Object.hasOwn(data, key)) {
                const newKey = keyMap[key] || key // rename if mapping exists
                if (typeof data[key] === 'object') {
                    newObj[newKey] = replaceKeys(data[key], keyMap)
                } else {
                    newObj[newKey] = data[key]
                }
            }
        }
        return newObj
    }
    return data
}
